import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

type TUseBrowserBack = {
  onBrowserHistoryChange: () => void;
};
const useBrowserBack = ({ onBrowserHistoryChange }: TUseBrowserBack): void => {
  const [locationKeys, setLocationKeys] = useState<any[]>([]);

  const history = useHistory();

  useEffect(() => {
    return history.listen((loc: any) => {
      if (history.action === 'PUSH') {
        setLocationKeys([loc.key]);
      }

      if (history.action === 'POP') {
        if (locationKeys[1] === loc.key) {
          onBrowserHistoryChange?.();
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          setLocationKeys(([_, ...keys]) => keys);
        } else {
          onBrowserHistoryChange?.();
          setLocationKeys((keys) => [loc.key, ...keys]);
        }
      }
    });
  }, [locationKeys]);
};

export default useBrowserBack;
